import { render, staticRenderFns } from "./Col11.vue?vue&type=template&id=fc2bbdc6&scoped=true"
import script from "./Col11.vue?vue&type=script&lang=js"
export * from "./Col11.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2bbdc6",
  null
  
)

export default component.exports